import React from 'react';

const Describe = () => {
    return (
        <div className='text-center mx-10 my-10'>
             <h1 className="text-4xl font-bold uppercase">How it Works?</h1>
             <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Est libero, eius rerum consequatur reprehenderit modi rem</p>
        </div>
    );
};

export default Describe;